import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { Rest } from 'app/rest/rest_client';

@Injectable()
export class UtilsService {
	constructor(private datePipe: DatePipe) {}

	//Posa els elements seleccionats a dalt de la llista del multiselect
	public onMultiSelectFocus(selectedCollection: any[], fullCollection: any[]): void {
		// sortSelectedItems
		selectedCollection?.forEach((selectedItem) => {
			// Find the index of the item in the list
			const indexToRemove = fullCollection?.findIndex((item) => item.id === selectedItem.id);

			if (indexToRemove !== -1) {
				// Remove the item from the list
				fullCollection.splice(indexToRemove, 1);
				// Add the selected item to the top of the list
				fullCollection.unshift(selectedItem);
			}
		});
	}

	public calculateInputsMarginTop(formInputs: any[]): number {
		const totalHeight = window.screen.height;
		var visibleCount = 0;
		formInputs.forEach((input) => {
			if (input.visible) {
				// Si 'cols' está definido, sumamos 0.5, de lo contrario, sumamos 1
				visibleCount += input.cols ? 0.5 : 1;
			}
		});
		if (visibleCount > 9) {
			return 0;
		}
		if (visibleCount > 8) {
			return 5;
		}
		if (visibleCount > 7) {
			return 10;
		}
		if (visibleCount > 6) {
			return 20;
		} else if (visibleCount > 5) {
			return 30;
		} else if (visibleCount > 4) {
			return 40;
		} else if (visibleCount > 3) {
			return 60;
		} else if (visibleCount > 2) {
			return 90;
		}
	}

	//#user-app-logistics-dialog .p-dialog-content
	scrollTop(querySelector): void {
		////scroll en el top
		setTimeout(() => {
			const contentElement = document.querySelector(querySelector);
			if (contentElement) {
				contentElement.scrollTop = 0;
			}
		}, 0);
	}

	blockCharacters(event: KeyboardEvent, charactersToBlock: string[]) {
		if (charactersToBlock.includes(event.key)) {
			event.preventDefault(); // Prevent the character from being entered
		}
	}
	calculateDiffInDays(startDate: Date, endDate: Date): number {
		if (!startDate || !endDate) {
			return 0;
		}

		const start = new Date(startDate).getTime();
		const end = new Date(endDate).getTime();

		const diffInMs = end - start;

		const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
		console.log('calculateDiffInDays ' + diffInDays);
		return diffInDays;
	}
	truncateDecimals(num: number, decimals: number): number {
		try {
			const factor = Math.pow(10, decimals);
			return Math.trunc(num * factor) / factor;
		} catch (error) {
			console.log(error);
			return num;
		}
	}

	timeStampToDate(timestamp: number, formatt: string): string | null {
		try {
			return this.datePipe.transform(timestamp, formatt); // O HH:ss si querés
		} catch (error) {
			console.log(error);
			return '';
		}
	}
	formatAddress(address: String, removeSubRegion: boolean): String {
		// Se separa la dirección por "|"
		if (address == null || address == '') {
			return '';
		}
		const parts = address.split('|');
		if (removeSubRegion) {
			// Eliminar el campo de subregion (por lo que asumo es el penúltimo o el último)
			parts.splice(5, 1); // Eliminamos el índice 5 (subregion)
		}
		// Unir las partes con una coma y devolver el resultado
		return parts.join(', ');
	}
	generateKML(messages: Rest.VehicleDataMessage[], title: string): string {
		let kmlContent = `<?xml version="1.0" encoding="UTF-8"?>
		<kml xmlns="http://www.opengis.net/kml/2.2">
			<Document>
			<name>${title}</name>
			<Placemark>
				<name>Ruta</name>
				<LineString>
				<coordinates>`;

		// Agregar las coordenadas al archivo KML
		messages.forEach((pos) => {
			kmlContent += `${pos.longitude},${pos.latitude},0\n`; // Longitud, latitud, altura
		});

		kmlContent += `</coordinates>
				</LineString>
			</Placemark>
			</Document>
		</kml>`;
		return kmlContent;
	}

	generateGPX(messages: Rest.VehicleDataMessage[], title: string): string {
		let gpxContent = `<?xml version="1.0" encoding="UTF-8"?>
  <gpx xmlns="http://www.topografix.com/GPX/1/1"
       version="1.1" 
       creator="AtlantisIT">
    <metadata>
      <name>${title}</name>
    </metadata>
    <trk>
      <name>${title}</name>
      <trkseg>`;

		// Agregar las coordenadas al archivo GPX
		messages.forEach((pos) => {
			gpxContent += `<trkpt lat="${pos.latitude}" lon="${pos.longitude}">
                    <ele>0</ele>
                    <time>${new Date().toISOString()}</time>
                  </trkpt>\n`;
		});

		gpxContent += `</trkseg>
  </trk>
  </gpx>`;

		return gpxContent;
	}
/*
	downloadKML(kmlContent: string, fileName: string = 'ruta.kml') {
		const blob = new Blob([kmlContent], { type: 'application/vnd.google-earth.kml+xml' });
		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download = fileName;
		link.click();
		URL.revokeObjectURL(url);
	}
	*/

	downloadFile(fileContent: string, fileName: string, fileType: string ) {
		//const blob = new Blob([gpxContent], { type: 'application/gpx+xml' });
		const blob = new Blob([fileContent], { type: fileType });
		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download = fileName;
		link.click();
		URL.revokeObjectURL(url);
	}

	formatDateForFile(date: Date): string {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0'); // Months start at 0, so we add 1
		const day = String(date.getDate()).padStart(2, '0');
		const hours = String(date.getHours()).padStart(2, '0');

		return `${year}-${month}-${day}_${hours}`;
	}
}
